import clsx from 'clsx'
import type { TextareaHTMLAttributes } from 'react'

export type AdminTextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  setValue?: (v: string) => void
}

export const AdminTextArea = ({
  className,
  setValue,
  ...props
}: AdminTextAreaProps) => {
  return (
    <textarea
      className={clsx('textarea w-full p-2 h-32', className)}
      onChange={e => {
        setValue?.(e.target.value)
        props.onChange?.(e)
      }}
      {...props}
    />
  )
}
